module.exports = __webpack_public_path__ + "img/closeVideo.6e59a196.svg";